// Colorea Mi Boda — scripts propios (vanilla, sin librerias externas)

function mtInitReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-stagger');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function mtInitGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-mt-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-galeria-principal]');
    var miniaturas = galeria.querySelectorAll('[data-mt-miniatura]');
    if (!principal || !miniaturas.length) return;
    miniaturas.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-full');
        if (!src) return;
        var img = principal.querySelector('img');
        if (img) img.setAttribute('src', src);
        miniaturas.forEach(function (m) { m.classList.remove('is-activa'); });
        mini.classList.add('is-activa');
      });
    });
  });
}

function mtInitVariantes() {
  var forms = document.querySelectorAll('[data-mt-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var pastillasWraps = form.querySelectorAll('[data-mt-opcion]');
    var idInput = form.querySelector('input[name="id"]');
    var seccion = form.closest('section');
    var precioEl = seccion ? seccion.querySelector('[data-mt-precio]') : form.querySelector('[data-mt-precio]');
    var precioComparadoEl = seccion ? seccion.querySelector('[data-mt-precio-comparado]') : form.querySelector('[data-mt-precio-comparado]');
    var boton = form.querySelector('[data-mt-add]');
    var galeriaPrincipal = seccion ? seccion.querySelector('[data-mt-galeria-principal]') : null;
    var miniaturasGaleria = seccion ? seccion.querySelectorAll('[data-mt-miniatura]') : [];
    var textoBoton = boton ? boton.querySelector('span') : null;
    var textosBoton = boton
      ? {
          disponible: boton.getAttribute('data-texto-disponible') || 'Add to cart',
          agotado: boton.getAttribute('data-texto-agotado') || 'Sold out',
          noDisponible: boton.getAttribute('data-texto-no-disponible') || 'Unavailable',
        }
      : {};

    function opcionesSeleccionadas() {
      var seleccion = [];
      pastillasWraps.forEach(function (wrap) {
        var activa = wrap.querySelector('.is-seleccionada');
        seleccion.push(activa ? activa.getAttribute('data-valor') : null);
      });
      return seleccion;
    }

    function encontrarVariante() {
      var seleccion = opcionesSeleccionadas();
      return variantes.find(function (v) {
        return v.options.every(function (op, i) { return op === seleccion[i]; });
      });
    }

    function formatearDinero(centavos) {
      if (window.Shopify && window.Shopify.formatMoney && window.themeMoneyFormat) {
        return window.Shopify.formatMoney(centavos, window.themeMoneyFormat);
      }
      return (centavos / 100).toFixed(2);
    }

    function actualizar() {
      var variante = encontrarVariante();
      if (!variante) {
        if (boton) boton.setAttribute('disabled', 'disabled');
        if (textoBoton) textoBoton.textContent = textosBoton.noDisponible;
        return;
      }
      if (idInput) idInput.value = variante.id;
      if (precioEl) precioEl.textContent = formatearDinero(variante.price);
      form.dispatchEvent(new CustomEvent('mt:precio-actualizado', { detail: { centavos: variante.price } }));
      if (precioComparadoEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioComparadoEl.textContent = formatearDinero(variante.compare_at_price);
          precioComparadoEl.hidden = false;
        } else {
          precioComparadoEl.hidden = true;
        }
      }
      if (boton) {
        if (variante.available) {
          boton.removeAttribute('disabled');
          if (textoBoton) textoBoton.textContent = textosBoton.disponible;
        } else {
          boton.setAttribute('disabled', 'disabled');
          if (textoBoton) textoBoton.textContent = textosBoton.agotado;
        }
      }
      if (galeriaPrincipal && variante.featured_image && variante.featured_image.src) {
        var imgPrincipal = galeriaPrincipal.querySelector('img');
        if (imgPrincipal) imgPrincipal.setAttribute('src', variante.featured_image.src);
        miniaturasGaleria.forEach(function (mini) {
          var esLaMisma = mini.getAttribute('data-full') === variante.featured_image.src;
          mini.classList.toggle('is-activa', esLaMisma);
        });
      }
    }

    pastillasWraps.forEach(function (wrap) {
      wrap.addEventListener('click', function (e) {
        var pastilla = e.target.closest('.mt-pastilla');
        if (!pastilla || pastilla.disabled) return;
        wrap.querySelectorAll('.mt-pastilla').forEach(function (p) { p.classList.remove('is-seleccionada'); });
        pastilla.classList.add('is-seleccionada');
        actualizar();
      });
    });

    actualizar();
  });
}

function mtInitCantidad() {
  var contenedores = document.querySelectorAll('[data-mt-cantidad]');
  contenedores.forEach(function (cont) {
    var input = cont.querySelector('[data-mt-cantidad-input]');
    var chips = cont.querySelectorAll('[data-mt-cantidad-chip]');
    var menos = cont.querySelector('[data-mt-cantidad-menos]');
    var mas = cont.querySelector('[data-mt-cantidad-mas]');
    var unidadEl = cont.querySelector('[data-mt-cantidad-unidad]');
    var totalEl = cont.querySelector('[data-mt-cantidad-total]');
    var form = cont.closest('form');
    var precioCentavos = parseInt(cont.getAttribute('data-precio-centavos'), 10) || 0;
    if (!input) return;

    function formatearDinero(centavos) {
      if (window.Shopify && window.Shopify.formatMoney && window.themeMoneyFormat) {
        return window.Shopify.formatMoney(centavos, window.themeMoneyFormat);
      }
      return '$' + (centavos / 100).toFixed(2);
    }

    function marcarChipActivo(cantidad) {
      chips.forEach(function (chip) {
        chip.classList.toggle('is-seleccionada', chip.getAttribute('data-valor') === String(cantidad));
      });
    }

    function actualizarTotales() {
      var cantidad = parseInt(input.value, 10);
      if (!cantidad || cantidad < 1) {
        cantidad = 1;
        input.value = 1;
      }
      if (unidadEl) unidadEl.textContent = formatearDinero(precioCentavos);
      if (totalEl) totalEl.textContent = formatearDinero(precioCentavos * cantidad);
      marcarChipActivo(cantidad);
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        input.value = chip.getAttribute('data-valor');
        actualizarTotales();
      });
    });

    if (menos) {
      menos.addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        actualizarTotales();
      });
    }
    if (mas) {
      mas.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
        actualizarTotales();
      });
    }
    input.addEventListener('input', actualizarTotales);

    if (form) {
      form.addEventListener('mt:precio-actualizado', function (e) {
        precioCentavos = e.detail.centavos;
        actualizarTotales();
      });
    }

    actualizarTotales();
  });
}

function mtInitPersonalizacion() {
  var forms = document.querySelectorAll('[data-mt-producto-form]');
  forms.forEach(function (form) {
    var campos = form.querySelectorAll('[data-mt-obligatorio]');
    if (!campos.length) return;
    form.addEventListener('submit', function (e) {
      var valido = true;
      campos.forEach(function (input) {
        var wrap = input.closest('.mt-campo');
        if (!input.value.trim()) {
          valido = false;
          if (wrap) wrap.classList.add('mt-campo--error');
        } else if (wrap) {
          wrap.classList.remove('mt-campo--error');
        }
      });
      if (!valido) {
        e.preventDefault();
        var primerError = form.querySelector('.mt-campo--error input');
        if (primerError) primerError.focus();
      }
    });
    campos.forEach(function (input) {
      input.addEventListener('input', function () {
        var wrap = input.closest('.mt-campo');
        if (wrap && input.value.trim()) wrap.classList.remove('mt-campo--error');
      });
    });
  });
}

function mtInitRegalo() {
  var toggles = document.querySelectorAll('[data-mt-regalo-toggle]');
  toggles.forEach(function (toggle) {
    var campo = toggle.closest('form').querySelector('[data-mt-regalo-campo]');
    if (!campo) return;
    toggle.addEventListener('change', function () {
      campo.classList.toggle('is-visible', toggle.checked);
    });
  });
}

function mtInitBumpCarrito() {
  var icono = document.getElementById('cart-icon-bubble');
  if (!icono || !window.fetch) return;
  var fetchOriginal = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = args[0] && args[0].url ? args[0].url : args[0];
    var esAgregarAlCarrito = typeof url === 'string' && url.indexOf('/cart/add') > -1;
    var promesa = fetchOriginal.apply(this, args);
    if (esAgregarAlCarrito) {
      promesa.then(function (res) {
        if (res && res.ok) {
          icono.classList.remove('mt-bump');
          void icono.offsetWidth;
          icono.classList.add('mt-bump');
        }
      });
    }
    return promesa;
  };
}

document.addEventListener('DOMContentLoaded', function () {
  mtInitReveal();
  mtInitGaleriaProducto();
  mtInitVariantes();
  mtInitCantidad();
  mtInitPersonalizacion();
  mtInitRegalo();
  mtInitBumpCarrito();
});
